"use strict";

exports.__esModule = true;
exports.LegacyController = void 0;
var _react = require("react");
var _UIVimanaReports = require("./UIVimanaReports");
var _excluded = ["settingsMenu"];
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * This context provides a simple hook for UI-vimana to inject props through to lib-ui. Do not use this
 * unless you have to. Eventually we want to remove all these props once we've migrated more of ui-vimana
 */
var LegacyController = exports.LegacyController = /*#__PURE__*/function (_Component) {
  function LegacyController() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = makeState(_this.props);
    return _this;
  }
  _inheritsLoose(LegacyController, _Component);
  var _proto = LegacyController.prototype;
  _proto.render = function render() {
    // eslint-disable-next-line no-unused-vars
    return this.props.children(this.state);
  };
  return LegacyController;
}(_react.Component);
LegacyController.defaultProps = {
  allowedPlants: [],
  settingsMenu: {
    showChangePlant: true,
    showCalendar: true,
    showPlan: false,
    showRuleConfiguration: true,
    showDocs: true,
    showSwitchPlant: true,
    showTargets: true,
    showRealData: true,
    showMockData: true,
    showAuditLogs: true
  },
  reports: [_UIVimanaReports.ACTIVITY_SUMMARY, _UIVimanaReports.HOURLY_ACTIVITY_SUMMARY, _UIVimanaReports.PERFORMANCE_GRID, _UIVimanaReports.PART_METRICS, _UIVimanaReports.OPERATOR_METRICS, _UIVimanaReports.TOOL_PERFORMANCE, _UIVimanaReports.CONDITIONS]
};
function makeState(_ref) {
  var settingsMenu = _ref.settingsMenu,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  return Object.assign({}, other, {
    settingsMenu: Object.assign({}, LegacyController.defaultProps.settingsMenu, settingsMenu)
  });
}